import { AfterViewInit, Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core';
import { CustomEventNewCardEnt } from '../../interfaces/custom-event-new-card-ent';

@Component({
  selector: 'app-custom-full-size-events-news',
  templateUrl: './custom-full-size-events-news.html'
})
export class CustomFullSizeEventsNewsComponent {
  @Input() eventnew : CustomEventNewCardEnt  = new CustomEventNewCardEnt;
  @ViewChild('eventContent') eventContent!: ElementRef<HTMLElement>;

  ngAfterViewInit(): void {
    if (this.eventContent && this.eventnew?.content) {
      this.eventContent.nativeElement.innerHTML = this.eventnew.content!;
    }
  }

  ngOnChanges() {
    if (this.eventContent && this.eventnew?.content) {
      this.eventContent.nativeElement.innerHTML = this.eventnew.content!;
    }
  }
}
